<template>
  <div>
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoadingList"
      :can-cancel="false"
    ></b-loading>
    <router-link class="button is-info is-small" :to="{ name: 'Create User' }">
      <span class="icon"> <i class="fas fa-plus"></i> </span>&nbsp; Create
      new</router-link
    >
    <b-table :data="isEmpty ? [] : users">
      <template slot-scope="props">
        <b-table-column field="id" label="User ID">
          {{ props.row.id }}
        </b-table-column>
        <b-table-column field="fullname" label="Fullname">
          {{ props.row.fullname }}
        </b-table-column>
        <b-table-column field="role" label="Role">
          <span v-for="userRole in props.row.userRoles">
            {{ userRole.role }},
          </span>
        </b-table-column>
        <b-table-column>
          <router-link
            :to="{
              name: 'User Annual Quota',
              params: { userId: props.row.id }
            }"
            class="button is-small"
            >Annual Quota</router-link
          >
          &nbsp;
          <router-link
            :to="{ name: 'Update User', params: { userId: props.row.id } }"
            class="button is-warning is-small"
            >Edit</router-link
          >
          &nbsp;
          <button
            class="button is-danger is-small"
            @click="deleteUser(props.row.id, props.row.fullname)"
          >
            Delete
          </button>
        </b-table-column>
      </template>
    </b-table>
    <app-delete />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Delete from "./Delete.vue";

export default {
  components: {
    appDelete: Delete
  },
  data() {
    return {
      isEmpty: false,
      isFullPage: true
    };
  },
  computed: {
    ...mapState("userManagement", {
      users: state => state.users,
      isLoadingList: state => state.isLoadingList
    })
  },
  methods: {
    ...mapActions("userManagement", ["getUsers", "openDeleteModal"]),
    deleteUser(id, fullname) {
      this.openDeleteModal({
        showDeleteModal: true,
        user: {
          id: id,
          fullname: fullname
        }
      });
    }
  },
  created() {
    this.getUsers();
  }
};
</script>
